/** App store listing URLs (override via Vite env when published). */
export const GOOGLE_PLAY_URL =
  import.meta.env.VITE_GOOGLE_PLAY_URL?.trim() || 'https://play.google.com/store';

export const APP_STORE_URL =
  import.meta.env.VITE_APP_STORE_URL?.trim() || 'https://www.apple.com/app-store/';
